import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const QS = [
  {
    q: "When is Frostico launching?",
    a: "September 2026, exclusively across Dorset and Hampshire. We're building an initial fleet of Frostico machines with a phased rollout starting in Bournemouth, Poole and Southampton.",
  },
  {
    q: "How does the 15% profit share for hosts work?",
    a: "You provide the floor space and power. Frostico ships, installs, restocks and services the machine. You keep 15% of net revenue, paid out monthly with a transparent dashboard.",
  },
  {
    q: "What does the ice cream taste like? Is it real Mr Whippy?",
    a: "Fresh vanilla soft-serve, made with real milk. Each cup comes with your choice of one dry topping (Rainbow Sprinkles, Choc Chips or Mini Marshmallows) and one sauce (Chocolate, Strawberry or Salted Caramel). Served in a cup in under 15 seconds.",
  },
  {
    q: "Can I book Frostico for a wedding or private event?",
    a: "Absolutely — for events in Dorset and Hampshire. Fill out the ‘Book for Event’ form and we’ll confirm availability within 24 hours. We travel to venues across both counties with basic power access.",
  },
  {
    q: "Is there any upfront cost to become a location partner?",
    a: "None. Frostico owns and maintains the machine at zero cost to you — we just ask for a minimum 12-month host agreement and reasonable access for restocking.",
  },
  {
    q: "How do payments work for customers?",
    a: "Contactless card and Apple/Google Pay only. No cash. Every transaction is logged, so your profit share is calculated automatically.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="relative py-24 md:py-36">
      <div className="mx-auto max-w-[1200px] px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="font-mono-accent text-[11px] text-[#5AB0FF] mb-4">
              FAQ
            </div>
            <h2 className="font-display text-5xl md:text-6xl font-bold tracking-tighter leading-[0.95]">
              Questions,
              <br />
              <span className="italic text-white/70">answered.</span>
            </h2>
            <p className="mt-6 text-white/60 max-w-sm leading-relaxed">
              Everything you need to know about hosting or hiring a Frostico
              machine. Still curious?{" "}
              <a
                href="#partner"
                className="text-[#8B5CF6] underline underline-offset-4"
              >
                Get in touch
              </a>
              .
            </p>
          </div>

          <div className="md:col-span-8">
            <Accordion type="single" collapsible className="w-full">
              {QS.map((qa, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-b border-white/10"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="py-6 text-left hover:no-underline">
                    <span className="flex items-baseline gap-4 text-lg md:text-xl font-medium">
                      <span className="font-mono-accent text-[11px] text-[#8B5CF6]">
                        Q.{String(i + 1).padStart(2, "0")}
                      </span>
                      {qa.q}
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="pb-6 pl-16 text-white/70 leading-relaxed">
                    {qa.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
